import { curry, pipe } from 'rambda';
import Constants from 'constants';
import genericConnector from 'services/connect/genericConnector';
import setConfirmJson from '../services/decorator/thankyou/setData';


const then = curry((f, p) => p.then(f)),

    getOpenBookingDetails = (payload) => {
        const options = {
            api: 'getOpenBookingDetails',
            content: { ...payload },
            ignoreAllError: true
        }
        return async (dispatch) => {
            dispatch({ type: Constants.actions.HCN_UPDATE.FETCHING_BOOKING_DETAILS });
            const res = await pipe(
                genericConnector,
                then(setConfirmJson)
            )(options);
            const { payload: response = {} } = res
            dispatch({
                type: Constants.actions.HCN_UPDATE.OPEN_BOOKING_DETAILS,
                payload: response
            });
        };
    },
    hcnUpdateSubmit = (payload) => {
        const options = {
            api: 'hccUpdateOpenApi',
            content: { ...payload },
            ignoreAllError: true
        }
        return async (dispatch) => {
            dispatch({ type: Constants.actions.HCN_UPDATE.UPDATING_HCN });
            const res = await genericConnector(options)
            const { payload: response = {} } = res
            dispatch({
                type: Constants.actions.HCN_UPDATE.HCN_UPDATED,
                payload: response
            });
        };
    };




export {
    getOpenBookingDetails,
    hcnUpdateSubmit
};
